import { singleton } from "tsyringe";

import { HookDefinition, HookFunction, HookInterface } from "./HookDefinition";

@singleton()
export class HooksManager {
    private hooks = new Map<string, HookFunction<unknown, unknown>>();

    public registerHook<TInput, TResult>(
        definition: HookDefinition<TInput, TResult>,
        hookFunction: HookFunction<TInput, TResult>
    ): void {
        this.hooks.set(
            definition.name,
            hookFunction as HookFunction<unknown, unknown>
        );
    }

    public findHook<TInput, TResult>(
        definition: HookDefinition<TInput, TResult>
    ): HookInterface<TInput, TResult> {
        const registeredHookFunction = this.hooks.get(definition.name);

        return {
            execute: async (input: TInput): Promise<TResult> => {
                if (!registeredHookFunction) {
                    return definition.defaultHandler(input);
                }

                try {
                    return (await registeredHookFunction(
                        input
                    )) as Promise<TResult>;
                } catch (error) {
                    console.error(
                        `Hook execution failed for ${definition.name}:`,
                        error
                    );
                    return definition.defaultHandler(input);
                }
            },
        };
    }
}
